import axios from 'axios'
import router from '@/router'
import { isAuthErrorType, HTTP_ERRORS_CODES } from '@/scripts/utils/error-mappings'
import store from '@/store/index'
import { trackNewrelicJSError } from '@/utils/newrelic'

const deleteUserAndRouteToLogin = (e) => {
  const userAuthenticated = store.getters['user/authentication/isAuthenticated']
  const route = router.currentRoute.value

  // If user is already logged out and in login, do nothing
  if (!userAuthenticated && route.name === 'login') {
    return Promise.reject(e)
  }

  // Prevent multiple logout calls: only dispatch logout if user is still authenticated
  const hasTokens = store.getters['user/authentication/isAuthenticated']

  if (hasTokens) store.dispatch('user/authentication/logout', { remoteLogout: false })

  router.replace({ name: 'login' }).catch(() => { })

  return Promise.reject(e)
}

const routeToDefaultPage = (e) => {
  const defaultRoute = 'feed-home'

  if (router.currentRoute.value.name === defaultRoute) return undefined
  router.replace({ name: defaultRoute })

  return Promise.reject(e)
}

/**
 * SWORD jwt interceptor
 */
axios.interceptors.response.use(
  (r) => r,
  async (e) => {
    // Safe check for further logic
    if (!e || !e.response || !e.response.status) {
      return Promise.reject(e)
    }

    trackNewrelicJSError(e, { url: e.config.url })

    // Validate that is and actual known auth issue
    /* eslint-disable no-prototype-builtins */
    if (!HTTP_ERRORS_CODES.hasOwnProperty(e.response.status)) {
      return Promise.reject(e)
    }

    const resp = e.response
    const orgRequest = e.config
    const accessTokenExpired = isAuthErrorType('ACCESS_TOKEN_EXPIRED', resp)
    const refreshToken = store.getters['user/authentication/refreshToken']
    const tryingToRefreshAccessToken = orgRequest.url.includes('auth/refresh')

    const shouldTryToRefreshAccessToken = accessTokenExpired && refreshToken && !tryingToRefreshAccessToken

    if (shouldTryToRefreshAccessToken) {
      console.log('User token is expired... Will refresh')
      try {
        const freshAccessToken = await store.dispatch('user/authentication/refreshAccessToken')

        // Set new token
        store.dispatch('user/authentication/updateAuthTokens', { accessToken: freshAccessToken })
        // Update original request
        orgRequest.headers.Authorization = freshAccessToken

        // Run Previous actions
        return axios.request(orgRequest)
      } catch (error) {
        console.error(error)
        deleteUserAndRouteToLogin(e)
      }
    }

    if (isAuthErrorType('AUTH_INVALID_TOKEN', resp) && HTTP_ERRORS_CODES[e.response.status] === 'FORBIDDEN') {
      console.log('Can\'t access resource. Routing to default page')

      return routeToDefaultPage(e)
    }

    if (isAuthErrorType('*', resp)) {
      console.log('User token is invalid...')

      return deleteUserAndRouteToLogin(e)
    }

    return Promise.reject(e)
  },
)
